import {Authority} from './Authority';

/**
 * Se utiliza esta clase para ser enviada al API, ya que no esta permitido en el API recibir una lista en el 'RequestBody'.
 */
export class AuthoritiesList {
  authorities: Authority[];
}
